/**
 * LES REACTIONS D'UN MESSAGE, cote interface : la liste FERMEE des trois
 * emojis (pouce, pouce bas, fete ; P19 du 06/10/2026) et leur cle de stockage. Un ancien
 * coeur (`coeur`) reste en base mais n'est pas dans la liste : il ne
 * s'affiche pas. RECOPIE de `@taki/data-model`
 * (`REACTIONS_DE_MESSAGE`, `message.ts`), que ce package n'importe pas ; un
 * test compare les deux (`packages/sdk/tests/conversations-contrat.test.mjs`).
 */
export const REACTIONS_DU_MESSAGE = [
  { cle: 'pouce', emoji: '\u{1F44D}' },
  { cle: 'pouceBas', emoji: '\u{1F44E}' },
  { cle: 'fete', emoji: '\u{1F389}' },
] as const;

/**
 * Ce que chaque reaction DIT, pour les lecteurs d'ecran et l'infobulle (P19
 * du 06/10/2026) : l'emoji seul ne se lit pas.
 */
export const LIBELLES_DE_REACTION: Readonly<Record<CleDeReaction, string>> = {
  pouce: 'J’approuve',
  pouceBas: 'Je désapprouve',
  fete: 'Bravo',
};

export type CleDeReaction = (typeof REACTIONS_DU_MESSAGE)[number]['cle'];

/** Qui a reagi, par cle : la forme stockee (`message.reactions`). */
export type ReactionsDuMessage = Partial<Record<CleDeReaction, readonly string[]>>;

/** Une reaction posee, telle que l'ecran la compte. */
export interface ReactionComptee {
  cle: CleDeReaction;
  emoji: string;
  personnes: readonly string[];
  /** La personne connectee en fait partie. */
  deMoi: boolean;
}

/** Les reactions posees (au moins une personne), dans l'ordre de la liste fermee. */
export function reactionsComptees(reactions: ReactionsDuMessage | undefined, moi: string | null): ReactionComptee[] {
  return REACTIONS_DU_MESSAGE.flatMap(({ cle, emoji }) => {
    const personnes = reactions?.[cle] ?? [];
    return personnes.length === 0 ? [] : [{ cle, emoji, personnes, deMoi: moi !== null && personnes.includes(moi) }];
  });
}
